(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recpies"] && !Shopify.designMode) return;
  try {
    
(function () {
  // ===== 自动居中（独立执行，不依赖下方任何检查，保证一定能跑）=====
  var sectionEl = document.getElementById('rct-{{ section.id }}');
  function centerSection() {
    if (!sectionEl) return;
    var vw = document.documentElement.clientWidth;
    sectionEl.style.setProperty('width', '100vw', 'important');
    sectionEl.style.setProperty('margin-left', 'calc(50% - 50vw)', 'important');
    sectionEl.style.setProperty('margin-right', '0', 'important');
    var rect = sectionEl.getBoundingClientRect();
    var w = sectionEl.offsetWidth;
    if (w < 1) return;
    var targetLeft = (vw - w) / 2;
    var diff = targetLeft - rect.left;
    if (Math.abs(diff) > 8) {
      sectionEl.style.transform = 'translateX(' + diff.toFixed(1) + 'px)';
    }
  }
  centerSection();
  window.addEventListener('resize', centerSection);
  document.addEventListener('DOMContentLoaded', centerSection);

  var section = document.querySelector('[data-rct-section="{{ section.id }}"]');
  if (!section) return;

  var nav = section.querySelector('[data-rct-filters]');
  var grid = section.querySelector('[data-rct-grid]');
  if (!grid) return;

  var cards = Array.prototype.slice.call(grid.querySelectorAll('.rct-card'));

  // 从卡片分类自动生成筛选按钮（保持出现顺序，去重）
  var seen = {};
  var cats = [];
  cards.forEach(function (card) {
    var c = (card.getAttribute('data-category') || '').trim();
    if (c && !seen[c]) { seen[c] = true; cats.push(c); }
  });

  if (nav) {
    cats.forEach(function (c) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rct-filter-btn';
      btn.setAttribute('data-filter', c);
      btn.textContent = c.charAt(0).toUpperCase() + c.slice(1);
      nav.appendChild(btn);
    });

    var buttons = Array.prototype.slice.call(nav.querySelectorAll('.rct-filter-btn'));

    function applyFilter(filter) {
      buttons.forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-filter') === filter);
      });
      cards.forEach(function (card) {
        var c = (card.getAttribute('data-category') || '').trim();
        card.style.display = (filter === 'all' || c === filter) ? '' : 'none';
      });
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        applyFilter(b.getAttribute('data-filter'));
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
